import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { serviceImages } from '../../constants/images';
import Footer from '../Footer';

const ITConsulting = () => {
  useEffect(() => {
    document.title = 'IT Consulting - Global Excellence';
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: '💡',
      title: 'IT Strategy',
      description: 'Strategic planning for technology implementation'
    },
    {
      icon: '🔄',
      title: 'Digital Transformation',
      description: 'Guiding businesses through digital evolution'
    },
    {
      icon: '🔒',
      title: 'Cybersecurity',
      description: 'Comprehensive security solutions and planning'
    },
    {
      icon: '☁️',
      title: 'Cloud Solutions',
      description: 'Cloud strategy and migration services'
    },
    {
      icon: '📊',
      title: 'Data Analytics',
      description: 'Data-driven insights and solutions'
    },
    {
      icon: '🛠️',
      title: 'Infrastructure',
      description: 'IT infrastructure planning and optimization'
    }
  ];

  const processSteps = [
    {
      number: '01',
      title: 'Assessment',
      description: 'Analyze current IT infrastructure and needs'
    },
    {
      number: '02',
      title: 'Strategy',
      description: 'Develop customized IT strategy'
    },
    {
      number: '03',
      title: 'Planning',
      description: 'Create detailed implementation plan'
    },
    {
      number: '04',
      title: 'Implementation',
      description: 'Execute strategic IT initiatives'
    },
    {
      number: '05',
      title: 'Monitoring',
      description: 'Track progress and performance'
    },
    {
      number: '06',
      title: 'Optimization',
      description: 'Continuous improvement and updates'
    }
  ];

  const technologies = [
    { icon: '☁️', name: 'AWS' },
    { icon: '☁️', name: 'Azure' },
    { icon: '🔒', name: 'Cisco' },
    { icon: '🔄', name: 'VMware' },
    { icon: '📊', name: 'Tableau' },
    { icon: '💾', name: 'Oracle' },
    { icon: '🔍', name: 'Splunk' },
    { icon: '🛡️', name: 'Palo Alto' }
  ];

  return (
    <>
    <div className="service-component-wrapper">
      {/* Hero Section */}
      <section className="service-component-hero">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="service-hero-content"
        >
          <h1 className="service-hero-title">IT Consulting</h1>
          <p className="service-hero-subtitle">
            Strategic IT solutions to drive your business forward
          </p>
        </motion.div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="service-overview-content">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="service-overview-text"
          >
            <h2>Expert IT Consulting Services</h2>
            <p>
              Our IT consulting services help businesses navigate the complex world
              of technology. We provide strategic guidance, implementation support,
              and ongoing optimization to ensure your IT infrastructure aligns with
              your business goals.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="service-overview-image"
          >
            <img src={serviceImages.itConsulting} alt="IT Consulting" />
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-features">
        <h2>Our Consulting Services</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="feature-card"
            >
              <span className="feature-icon">{feature.icon}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="service-process">
        <h2>Our Consulting Process</h2>
        <div className="process-grid">
          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="process-card"
            >
              <span className="process-number">{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Technologies Section */}
      <section className="service-technologies">
        <h2>Technologies We Work With</h2>
        <div className="tech-grid">
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="tech-item"
            >
              <span className="tech-icon">{tech.icon}</span>
              <span className="tech-name">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="cta-content"
        >
          <h2 style={{color: 'white'}}>Ready to Transform Your IT Strategy?</h2>
          <p style={{color: 'white'}}>Let's discuss how we can help you achieve your technology goals</p>
          <div className="cta-buttons">
            <Link to="/contactus" className="cta-button primary">
              Get Started
            </Link>
            <Link to="/services" className="cta-button secondary">
              View All Services
            </Link>
          </div>
        </motion.div>
      </section>
    </div>
    <Footer />
    </>
  );
};

export default ITConsulting; 